import { EDIT } from 'pages/AddEditWorker/contants.js';
import  {
  WORKER_DETAILS_LOADING,
  WORKER_DETAILS_SUCCESS,
  WORKER_DETAILS_FAILED,
  RESET_WORKER_DETAILS,
  WORKER_ROLES_LOADING,
  WORKER_ROLES_SUCCESS,
  WORKER_ROLES_FAILED,
  WORKER_SCHEDULE_SUCCCESS,
  ROLE_UPDATE
} from '../CONSTANTS.js';
import  { EmailDomain } from 'config/CONSTANTS';
import {
  getWorkerDetails,
  getAllWorkerRoles,
  editContingentWorker,
  getNewCwkId,
  addContingentWorker,
  updateWorkerSchedule,
  saveWorkerIMTimeRoleData,
  addWorkerRoles,
  updateIMWarehouseRoles,
  saveWorkerGdeData,
  saveWorkerSBSData,
  saveWorkerTransportData,
  saveWorkerCrozierData,
  saveWorkerSecurebaseData,
  saveWorkerSmartSortUserData,
  saveWorkerGorpaData,
  saveWorkerLogITData
} from 'services';
import { workersRef } from 'services/firebase.js';
import { getWorkerSchedule } from 'services/workerSchedule.js';
import _ from "lodash";

const getWorkerDetailsWithRolesFailed = (payload) => ({
  type: WORKER_DETAILS_FAILED,
  payload
})

export const getWorkerDetailsWithRolesSuccess = (payload) => ({
  type: WORKER_DETAILS_SUCCESS,
  payload
})

const getWorkerDetailsWithRolesLoading = (payload) => ({
  type: WORKER_DETAILS_LOADING,
  payload
})

export const resetWorkerDetails = (payload) => ({
  type: RESET_WORKER_DETAILS,
  payload
})

const workerRolesLoading = (payload) => ({
  type: WORKER_ROLES_LOADING,
  payload
})

const workerRolesSuccess= (payload) => ({
  type: WORKER_ROLES_SUCCESS,
  payload
})

const workerRolesFailed = (payload) => ({
  type: WORKER_ROLES_FAILED,
  payload
})

const workerSchedule = (payload) => ({
  type: WORKER_SCHEDULE_SUCCCESS,
  payload
})

const roleUpdateAction = (payload) => ({
  type: ROLE_UPDATE,
  payload
})

/** User Details
 * Fetching worker Details with Roles
 * @param {*} workerId 
 * @returns : stores worker details with Roles in redux
 */
export const getWorkerDetailsWithRoles = (workerId) => async (dispatch) => {
  try{
    console.log("Inside getWorkerDetailsWithRoles", workerId);
    dispatch(getWorkerDetailsWithRolesLoading(true));
    dispatch(getWorkerRolesAction(workerId));
   await getWorkerDetails(workerId).then(workerDoc => {
      const workerDetails = {...workerDoc.data(), workerId: workerDoc.id};
      if(!workerDoc.exists){
        console.log("No Doc found for ", workerId);
        dispatch(getWorkerDetailsWithRolesFailed(`No Document found with Worker Id - ${workerId} `))
      }else{
        dispatch(getWorkerDetailsWithRolesSuccess(workerDetails));
        console.log("Inside getWorkerDetailsWithRoles", workerDetails);
      }
    });
    
  }catch (error) {
    console.log("getWorkerDetailsWithRoles error", error);
    dispatch(getWorkerDetailsWithRolesFailed(error));
  }finally{
    dispatch(getWorkerDetailsWithRolesLoading(false));
  }
}

// export const getWorkerRolesAction = (workerId) => async (dispatch) => {
//   try{
//     console.log("Inside getWorkerRolesAction", workerId);
//     dispatch(workerRolesLoading(true));
//     getAllWorkerRoles(workerId).then(response => {
//       if(response){
//           dispatch(workerRolesSuccess(response));
//       }
//     });
//     getWorkerSchedule(workerId).then(response => {
//       if(response){
//         dispatch(workerSchedule(response));
//       }
//     });
//   }catch(error){
//     console.log("getWorkerRolesAction", error);
//     dispatch(workerRolesFailed(error));
//   }finally{
//     dispatch(workerRolesLoading(false));
//   }
// }

export const getWorkerRolesAction = (workerId) => async (dispatch) => {
  dispatch(workerRolesLoading(true));

  // array of promises
  const workerRolesPromise = getAllWorkerRoles(workerId);
  const workerSchedulePromise = getWorkerSchedule(workerId);

  try {
    // Wait for both promises to settle
    const [workerRolesResult, workerScheduleResult] = await Promise.allSettled([workerRolesPromise, workerSchedulePromise]);
    console.log("Inside getWorkerRolesAction", workerRolesResult, workerScheduleResult)
    // Handle worker roles response
    if (workerRolesResult.status === "fulfilled" && workerRolesResult.value) {
      dispatch(workerRolesSuccess(workerRolesResult.value));
    } else if (workerRolesResult.status === "rejected") {
      console.log("Error in workerRoles:", workerRolesResult.reason);
      dispatch(workerRolesFailed(workerRolesResult.reason));
    }

    // Handle worker schedule response
    if (workerScheduleResult.status === "fulfilled" && workerScheduleResult.value) {
      dispatch(workerSchedule(workerScheduleResult.value));
    } else if (workerScheduleResult.status === "rejected") {
      console.log("Error in workerSchedule:", workerScheduleResult.reason);
      // Optionally dispatch some error state for workerSchedule
    }
  } catch (error) {
    console.log("Unexpected error:", error);
    dispatch(workerRolesFailed(error));
  } finally {
    // This block is guaranteed to run after both promises settle
    dispatch(workerRolesLoading(false));
  }
};




export const updateWorker = (workerData, timeRole) => async (dispatch) => {
  try{
    dispatch(getWorkerDetailsWithRolesLoading(true));
    let timeRoleDoc = null;
    const isApproverFlag = timeRole?.role === "Worker" ? false : true;
    console.log("update timeRole", isApproverFlag, workerData?.isApprover, timeRole);
    if(workerData?.isApprover !== null  && isApproverFlag !== workerData?.isApprover){
      console.log("update timeRole", timeRole);
      timeRoleDoc = {
        isActive: timeRole.isActive ? true : false,
        activityFamilyId: 'timeRole',
        role: workerData?.isApprover === true ? 'Supervisor' : "Worker",
        isScannerOnly: timeRole.isScannerOnly ? true: false,
        actionBy: workerData?.actionBy || workerData?.managerId,
        actionTS: workerData?.actionTS || new Date().toISOString()
      }
    }
    const editWorkerResult = await editContingentWorker(workerData, null, null, null, null, null, timeRoleDoc, null, null, null)
      if(editWorkerResult){
        console.log("updateWorker result", editWorkerResult);
        dispatch(getWorkerDetailsWithRoles(workerData?.workerId));
        return {success: true}
      }else{
        return { success: false, error: "Unknown error occurred" };
      }
  }catch(error){
    console.log("updateWorker error", error);
    return {success: false, message: error};
  }
}

export const addNewWorker = (workerData) => async (dispatch) => {
  try{
    dispatch(getWorkerDetailsWithRolesLoading(true));
      // First, get the new CWK ID (worker ID)
      const result = await getNewCwkId(workerData.country);
      let resultArr = result.toString().split(",");
      console.log("NEW CWK ID=== ", resultArr[0].toString());
  
      // Prepare the worker data
      const tempWorker = {
        ...workerData,
        workerId: resultArr[0].toString(),
        country: workerData.country,
        countryCode: resultArr[1].toString(),
        isNoEmail: workerData.isNoEmail,
      };
  
      // Set the email if not provided and email is required
      if (tempWorker.email === "") {
        tempWorker.email = resultArr[0].toString() + EmailDomain;
        tempWorker.isNoEmail = true;
      }
  
      console.log("NEW Worker=", tempWorker);

      const timeRoleDoc = {
        actionTS: tempWorker.actionTS,
        actionBy: tempWorker.actionBy,
        isScannerOnly: false,
        role: tempWorker.isApprover ? "Supervisor": "Worker",
        isActive: true,
        activityFamilyId: 'timeRole'
      }
  
    const addWorkerResult = await addContingentWorker(tempWorker, null, null, null, null, null, timeRoleDoc, null, null, null)
      if(addWorkerResult){
        console.log("addNewWorker result", addWorkerResult);
        dispatch(getWorkerDetailsWithRoles(tempWorker?.workerId));
        return {success: true, data: tempWorker};
      }else{
        return { success: false, error: "Unknown error occurred" };
      }
  }catch(error){
    console.log("addNewWorker error", error);
    return {success: false, message: error};
  }
}


/**
 * IMTime actions
 * @param {*} timeRoleDoc 
 * @param {*} workerScheduleDoc 
 * @param {*} workerData 
 * @param {*} shouldUpdateWorker 
 * @returns 
 */
export const updateIMTimeAccess = (timeRoleDoc, workerScheduleDoc, workerData, shouldUpdateWorker) => async (dispatch) => {
  try{
    dispatch(workerRolesLoading(true));
    if(!workerData && !workerData.workerId){
      return;
    }
    console.log("updateIMTimeAccess", timeRoleDoc, workerScheduleDoc)
    console.log("updateIMTimeAccess", workerData, shouldUpdateWorker)

      const result = {};
            // array of promises
        const workerColRef = workersRef().doc(workerData.workerId)
        const timeRolePromise = saveWorkerIMTimeRoleData({...workerData}, timeRoleDoc, workerColRef);
        const workerSchedulePromise = updateWorkerSchedule({...workerData}, workerScheduleDoc, workerData.workerId);
        const [workerRolesResult, workerScheduleResult] = await Promise.allSettled([timeRolePromise, workerSchedulePromise]);
  
        if (workerRolesResult.status === "fulfilled" && workerRolesResult.value) {
          result.success = true;
          dispatch(roleUpdateAction({key: 'timeRole', value: {...timeRoleDoc}, isEnabled: timeRoleDoc?.isActive }))
        }else if (workerRolesResult.status === "rejected") {
          console.log("Error in saveWorkerIMTimeRoleData:", workerRolesResult.reason);
          result.success = false;
          result.message = "IMTIme Access failed to update."
          // Optionally dispatch some error state for workerSchedule
        }

        if (workerScheduleResult.status === "fulfilled" && workerScheduleResult.value) {
          result.success = true;
          dispatch(workerSchedule(workerScheduleDoc));

        }else if (workerScheduleResult.status === "rejected") {
          console.log("Error in saveWorkerIMTimeRoleData:", workerScheduleResult.reason);
          result.success = false;
          result.message = `${result.message || ""} Worker schedule failed to update.` 
          // Optionally dispatch some error state for workerSchedule
        }

        if(shouldUpdateWorker){
          console.log("updateIMTimeAccess shouldUpdateWorker", shouldUpdateWorker)
          const editWorkerResult = await editContingentWorker(workerData, null, null, null, null, null, null, null, null, null)
          if(editWorkerResult){
            console.log("updateWorker result", editWorkerResult);
           await dispatch(getWorkerDetailsWithRoles(workerData?.workerId));
          }else{
            return { success: false, error: "updateWorker failed." };
          }
        }

        return result

  }catch(error){
    console.log("updateImTimeAccess", error);
  }finally{
    dispatch(workerRolesLoading(false));
  }
}

export const updateIMWarehouseAccess = (workerRoles, workerId, actionBy, updatedWareHouseDoc, activityFamilyIds, isEnabled) => async (dispatch) =>{
  try{
    console.log("Inside updateIMWarehouseAccess")
    dispatch(workerRolesLoading(true));
    if(!workerId){
    //  throw new Error("worker id is required to update");
      return;
    }
    if(!workerRoles && !workerRoles.length > 0){
     // throw new Error("workerRoles is empty");
       return ;
    }
    console.log("Inside updateIMWarehouseAccess", updatedWareHouseDoc)

    //const response = await addWorkerRoles(workerId, workerRoles, actionBy );
    const response = await updateIMWarehouseRoles(workerId, workerRoles, actionBy, activityFamilyIds );
    if(response && response.status){
      dispatch(roleUpdateAction({
        key: 'imWarehouse', 
        value: {...updatedWareHouseDoc}, 
        isEnabled: isEnabled
      }))
      return {status: true}
    }else{
      return {status: false, message : "AddWorkerRoles worker Roles Failed."}
    }


  }catch(error){
    console.log("updateIMWarehouseAccess error", error);
    return {status: false, message : error }
  }finally{
    dispatch(workerRolesLoading(false));
  }
}

export const updateGDEAccess = (updateData, workerData) => async (dispatch) =>{
  try{
    console.log("Inside updateGDEAccess")
    dispatch(workerRolesLoading(true));
    if(!workerData?.workerId){
        throw new Error("worker id is required to update");
      return;
    }
    if(!updateData?.gdeRole){
     throw new Error("Gde data is invalid");
       return ;
    }
    console.log("Inside updateGDEAccess", updateData)

    const workerColRef = workersRef().doc(workerData.workerId)
    const response = await saveWorkerGdeData(workerData, updateData,  workerColRef);
    if(response){
      dispatch(roleUpdateAction({
        key: 'gde', 
        value: {...updateData}, 
        isEnabled: updateData?.isActive
      }))
      return {status: true}
    }else{
      return {status: false, message : "AddWorkerRoles worker Roles Failed."}
    }
  }catch(error){
    console.log("updateGDEAccess error", error);
    return {status: false, message : error }
  }finally{
    dispatch(workerRolesLoading(false));
  }
}

export const updateSBSAccess = (updatedData, workerData) => async (dispatch) =>{
  try{
    console.log("Inside updateSBSAccess")
    dispatch(workerRolesLoading(true));
    if(!workerData?.workerId){
        throw new Error("worker id is required to update");
      return;
    }
    if(!updatedData?.role){
     throw new Error("SBS data is invalid");
       return ;
    }
    console.log("Inside updateSBSAccess", updatedData)

    const workerColRef = workersRef().doc(workerData.workerId)
    const response = await saveWorkerSBSData(workerData, updatedData,  workerColRef);
    if(response){
      dispatch(roleUpdateAction({
        key: 'SBS', 
        value: {...updatedData},
        isEnabled: updatedData?.isActive
      }))
      return {status: true}
    }else{
      return {status: false, message : "AddWorkerRoles worker Roles Failed."}
    }
  }catch(error){
    console.log("updateSBSAccess error", error);
    return {status: false, message : error }
  }finally{
    dispatch(workerRolesLoading(false));
  }
}

export const updateTransportationAccess = (updatedData, workerData) => async (dispatch) =>{
  try{
    console.log("Inside updateTransportationAccess")
    dispatch(workerRolesLoading(true));
    if(!workerData?.workerId){
        throw new Error("worker id is required to update");
      return;
    }
    if(!updatedData?.role){
     throw new Error("Transportation data is invalid");
       return ;
    }
    console.log("Inside updateTransportationAccess", updatedData)

    const workerColRef = workersRef().doc(workerData.workerId);
     const workerDoc = {
            actionBy: updatedData?.workerId || "",
            actionTS: new Date().toISOString(),
            actionType: EDIT,
            workerId: workerData.workerId,
            isTransportation: updatedData?.isActive ? true : false
    }
    //const response = await saveWorkerTransportData(workerData, updatedData,  workerColRef);
    const editWorkerResult = await editContingentWorker(workerDoc, null, null, updatedData, null, null, null, null, null, null);
      if(editWorkerResult){
      dispatch(roleUpdateAction({
        key: 'transportation', 
        value: {...updatedData},
        isEnabled: updatedData?.isActive
      }))
      return {status: true}
    }else{
      return {status: false, message : "AddWorkerRoles worker Roles Failed."}
    }
  }catch(error){
    console.log("updateTransportationAccess error", error);
    return {status: false, message : error }
  }finally{
    dispatch(workerRolesLoading(false));
  }
}

export const updateCrozierAccess = (updatedData, workerData) => async (dispatch) =>{
  try{
    console.log("Inside updateCrozierAccess")
    dispatch(workerRolesLoading(true));
    if(!workerData?.workerId){
        throw new Error("worker id is required to update");
      return;
    }
    console.log("Inside updateCrozierAccess", updatedData)

    const workerColRef = workersRef().doc(workerData.workerId)
    const response = await saveWorkerCrozierData(workerData, updatedData,  workerColRef);
    if(response){
      dispatch(roleUpdateAction({
        key: 'crozier', 
        value: {...updatedData},
        isEnabled: updatedData?.isActive
      }))
      return {status: true}
    }else{
      return {status: false, message : "AddWorkerRoles worker Roles Failed."}
    }
  }catch(error){
    console.log("updateCrozierAccess error", error);
    return {status: false, message : error }
  }finally{
    dispatch(workerRolesLoading(false));
  }
}

export const updateSecurebaseAccess = (updatedData, workerData) => async (dispatch) =>{
  try{
    console.log("Inside updateSecurebaseAccess")
    dispatch(workerRolesLoading(true));
    if(!workerData?.workerId){
        throw new Error("worker id is required to update");
      return;
    }
    if(!updatedData?.role){
      throw new Error("worker id is required to update");
    return;
    }
    console.log("Inside updateSecurebaseAccess", updatedData)

    const workerColRef = workersRef().doc(workerData.workerId)
    const response = await saveWorkerSecurebaseData(workerData, updatedData,  workerColRef);
    if(response){
      dispatch(roleUpdateAction({
        key: 'SECUREBASE', 
        value: {...updatedData},
        isEnabled: updatedData?.isActive
      }))
      return {status: true}
    }else{
      return {status: false, message : "AddWorkerRoles worker Roles Failed."}
    }
  }catch(error){
    console.log("updateSecurebaseAccess error", error);
    return {status: false, message : error }
  }finally{
    dispatch(workerRolesLoading(false));
  }
}

export const updateoneilAccess = (updatedData, workerData) => async (dispatch) =>{
  try{
    console.log("Inside updateoneilAccess")
    dispatch(workerRolesLoading(true));
    if(!workerData?.workerId){
        throw new Error("worker id is required to update");
      return;
    }
    if(!updatedData?.role){
      throw new Error("worker id is required to update");
    return;
    }
    console.log("Inside updateoneilAccess", updatedData)

    const workerColRef = workersRef().doc(workerData.workerId)
    const response = await saveWorkerSmartSortUserData(workerData, updatedData,  workerColRef);
    if(response){
      dispatch(roleUpdateAction({
        key: 'ONEIL', 
        value: {...updatedData},
        isEnabled: updatedData?.isActive
      }))
      return {status: true}
    }else{
      return {status: false, message : "AddWorkerRoles worker Roles Failed."}
    }
  }catch(error){
    console.log("updateoneilAccess error", error);
    return {status: false, message : error }
  }finally{
    dispatch(workerRolesLoading(false));
  }
}

export const updateGorpaAccess = (updatedData, workerData) => async (dispatch) =>{
  try{
    console.log("Inside updateGorpaAccess")
    dispatch(workerRolesLoading(true));
    if(!workerData?.workerId){
        throw new Error("worker id is required to update");
      return;
    }
    if(!updatedData?.role){
      throw new Error("worker id is required to update");
    return;
    }
    console.log("Inside updateGorpaAccess", updatedData)

    const workerColRef = workersRef().doc(workerData.workerId)
    const response = await saveWorkerGorpaData(workerData, updatedData,  workerColRef);
    if(response){
      dispatch(roleUpdateAction({
        key: 'gorpa', 
        value: {...updatedData},
        isEnabled: updatedData?.isActive
      }))
      return {status: true}
    }else{
      return {status: false, message : "AddWorkerRoles worker Roles Failed."}
    }
  }catch(error){
    console.log("updateGorpaAccess error", error);
    return {status: false, message : error }
  }finally{
    dispatch(workerRolesLoading(false));
  }
}

export const updateLogITAccess = (updatedData, workerData) => async (dispatch) =>{
  try{
    console.log("Inside updateLogITAccess")
    dispatch(workerRolesLoading(true));
    if(!workerData?.workerId){
        throw new Error("worker id is required to update");
      return;
    }
    if(!updatedData?.role){
      throw new Error("worker id is required to update");
    return;
    }
    console.log("Inside updateLogITAccess", updatedData)

    const workerColRef = workersRef().doc(workerData.workerId)
    const response = await saveWorkerLogITData(workerData, updatedData,  workerColRef);
    if(response){
      dispatch(roleUpdateAction({
        key: 'logIT',
        value: {...updatedData},
        isEnabled: updatedData?.isActive
      }))
      return {status: true}
    }else{
      return {status: false, message : "AddWorkerRoles worker Roles Failed."}
    }
  }catch(error){
    console.log("updateLogITAccess error", error);
    return {status: false, message : error }
  }finally{
    dispatch(workerRolesLoading(false));
  }
}